<template>
    <v-container v-if="existeIndicador">
        <v-card outlined class="mx-auto my-5" rounded="lg" :elevation="elevacion_cards">
            <v-container>
                <v-row class="titulo-indicador rounded-t-lg">
                    <v-card-title
                        class="font-weight-bold"
                        :class="esMovil ? 'subtitle-2' : 'subtitle-1'"
                        v-text="tituloIndicador"
                    >
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <v-card-subtitle>
                        <h1
                            class="dato-indicador font-weight-bold ma-0"
                            :class="esMovil ? 'text-h5' : 'text-h4'"
                        >
                            {{ indicador.valor_indicador | separadores }}
                            <span class="text-subtitle-1 font-weight-bold">
                                {{ indicador.unidad_medida }}
                            </span>
                        </h1>
                    </v-card-subtitle>
                </v-row>

                <BotonesCompartir
                    v-if="existeIndicador"
                    :indicador="indicador"
                ></BotonesCompartir>

                <v-card-text>
                    <v-row class="texto-detalle mt-3">
                        <v-col cols="12">
                            {{ indicador.definicion }}
                        </v-col>
                        <v-col cols="12">
                            <span class="font-weight-bold">
                                {{ $t("detalles.texto.fuente") }}
                            </span>
                            {{ indicador.fuentes_informacion }}
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-container>
        </v-card>
        <v-row justify="center" v-if="graficasCargadas">
            <v-col
                v-for="(grafica, index) in array_graficas"
                :key="index"
                cols="12"
                :md="grafica.columnas"
            >
                <v-card
                    outlined
                    class="mx-auto"
                    rounded="lg"
                    :elevation="elevacion_cards"
                >
                    <v-card-title class="titulo-detalle" v-text="grafica.descripcion">
                    </v-card-title>
                    <v-card-text>
                        <MostrarGrafica
                            :tipo="grafica.tipo"
                            :datos_grafica="grafica.datos_grafica"
                        >
                        </MostrarGrafica>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-card outlined rounded="lg" class="my-5 pa-2" :elevation="elevacion_cards">
            <v-card-title class="titulo-detalle">
                {{ $t("detalles.texto.objetivos") }}
            </v-card-title>
            <v-card-text>
                <v-container class="texto-detalle">
                    <v-row no-gutters>
                        <v-col cols="12" md="6">
                            <span class="font-weight-bold">
                                {{ $t("detalles.texto.resultado-esperado") }}
                            </span>
                            {{ $t("indicador." + indicador.id + ".resultado_esperado") }}
                        </v-col>
                        <v-col cols="12" md="3">
                            <span class="font-weight-bold">
                                {{ $t("detalles.texto.valor-partida") }}</span
                            >
                            {{ indicador.valor_partida }}
                        </v-col>
                        <v-col cols="12" md="3">
                            <span class="font-weight-bold">
                                {{ $t("detalles.texto.valor-objetivo") }}
                            </span>
                            {{ indicador.valor_2030 }}
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>

        <v-card outlined rounded="lg" class="my-5 pa-2" :elevation="elevacion_cards">
            <v-card-title class="titulo-detalle">
                {{ $t("detalles.texto.agenda-urbana") }}
            </v-card-title>
            <v-container>
                <v-row
                    v-for="(listaEnlacesObjetivos, index) in listaIndicadoresDividida"
                    :key="index"
                    justify="center"
                    justify-sm="start"
                >
                    <v-avatar
                        v-for="enlace in listaEnlacesObjetivos"
                        :key="enlace.id"
                        size="60"
                        class="ma-2"
                        :class="[
                            indicador.lista_objetivos_especificos.includes(enlace.id)
                                ? ''
                                : 'disabled',
                            esMovil ? 'mx-auto' : ' ml-4',
                        ]"
                    >
                        <router-link :to="enlace.link">
                            <v-img :src="enlace.icono" max-width="60"> </v-img>
                        </router-link>
                    </v-avatar>
                </v-row>
                <v-row class="my-4" justify-md="start" justify="center">
                    <v-chip
                        class="px-2 mx-2 mt-1"
                        label
                        dark
                        v-for="hashtag in indicador.enlaces_hashtags"
                        :key="hashtag.hashtag"
                        :color="hashtag.color"
                        :to="hashtag.link"
                    >
                        {{ hashtag.hashtag }}
                    </v-chip>
                </v-row>
            </v-container>
        </v-card>

        <v-card outlined rounded="lg" class="my-5 pa-2" :elevation="elevacion_cards">
            <v-card-title class="titulo-detalle">
                {{ $t("detalles.texto.agenda-2030") }}
            </v-card-title>
            <v-container>
                <v-row justify-md="start" justify="center">
                    <v-avatar
                        v-for="enlace in enlacesAgenda2030"
                        :key="enlace.id"
                        size="60"
                        tile
                        class="ma-2"
                        :class="
                            indicador.lista_objetivos_2030.includes('' + enlace.id)
                                ? ''
                                : 'disabled'
                        "
                    >
                        <v-img :src="enlace.icono" max-width="60"> </v-img>
                    </v-avatar>
                </v-row>
            </v-container>
        </v-card>

        <v-card outlined rounded="lg" class="my-5 pa-2" :elevation="elevacion_cards">
            <v-card-title class="titulo-detalle pb-0">
                {{ $t("detalles.texto.definicion") }}
            </v-card-title>
            <v-container class="texto-detalle" :class="esMovil ? 'text-body-2' : ''">
                <v-row no-gutters>
                    <v-col cols="12">
                        <span class="font-weight-bold">
                            {{ indicador.nombre }}
                        </span>
                    </v-col>
                    <v-col cols="12"> {{ indicador.definicion }} </v-col>
                </v-row>
                <v-row no-gutters class="mt-3">
                    <v-col cols="12">
                        <span class="font-weight-bold">
                            {{ $t("detalles.texto.unidad-medida") }}
                        </span>
                        {{ indicador.unidad_medida }}
                    </v-col>
                    <v-col cols="12">
                        <span class="font-weight-bold">
                            {{ $t("detalles.texto.tipo-indicador") }}
                        </span>
                        {{ indicador.tipo_indicador }}
                    </v-col>
                    <v-col cols="12">
                        <span class="font-weight-bold">
                            {{ $t("detalles.texto.metodologia") }}
                        </span>
                        {{ indicador.metodologia }}
                    </v-col>
                </v-row>
                <v-row no-gutters class="mt-3">
                    <v-col cols="12">
                        <span class="font-weight-bold">
                            {{ $t("detalles.texto.indicadores-asociados") }}
                        </span>
                    </v-col>
                    <v-col
                        cols="12"
                        v-for="relacionado in indicador.indicadores_relacionados"
                        :key="relacionado.id"
                    >
                        <router-link
                            class="enlace-detalles"
                            :to="{
                                name: 'detalles',
                                params: { id: relacionado.id },
                            }"
                        >
                            {{ $t(`indicador.${relacionado.id}.nombre`) }}
                        </router-link>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <v-row justify="end">
            <v-btn
                dark
                depressed
                @click="$router.go(-1)"
                class="ma-3 boton-detalles text-capitalize font-weight-bold"
            >
                {{ $t("detalles.texto.volver") }}
            </v-btn>
        </v-row>
    </v-container>
    <v-container v-else>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-text class="my-10 px-4 text--bold">
                        {{ $t("detalles.texto.no-existe-indicador") }}
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import GraficasService from "@services/GraficasService";
import IndicadoresService from "@services/IndicadoresService";
import MasterdataService from "../services/MasterdataService";
import MostrarGrafica from "@components/MostrarGrafica.vue";
import BotonesCompartir from "@components/BotonesCompartir.vue";

export default {
    name: "DetallesIndicador",
    props: ["id"],
    components: {
        MostrarGrafica,
        BotonesCompartir,
    },
    data: () => ({
        indicador: {},
        elevacion_cards: 4,
        graficasCargadas: false,
        array_graficas: [],
        enlacesObjetivos: [],
        enlacesAgenda2030: [],
    }),
    computed: {
        tituloIndicador() {
            return this.existeIndicador ? this.indicador.nombre : "";
        },

        existeIndicador() {
            return (
                this.indicador &&
                this.indicador.constructor === Object &&
                Object.keys(this.indicador).length !== 0
            );
        },
        listaIndicadoresDividida() {
            return this.esMovil
                ? [this.enlacesObjetivos.slice(0, 5), this.enlacesObjetivos.slice(5)]
                : [this.enlacesObjetivos];
        },

        esMovil() {
            return this.$vuetify.breakpoint.smAndDown;
        },
    },

    filters: {
        separadores: GraficasService.addSeparadores,
    },

    mounted() {
        this.cargarDatos();
    },

    watch: {
        "$route.params.id"() {
            this.cargarDatos();
        },
    },

    methods: {
        cargarDatos() {
            IndicadoresService.getIndicador(this.id, {
                acceso: this.$route.query.acceso,
            })
                .then((response) => {
                    this.indicador = response.data;
                })
                .catch((exception) => {
                    this.indicador = null;
                });

            this.graficasCargadas = false;
            GraficasService.getGraficas(this.id, {
                acceso: this.$route.query.acceso,
            }).then((response) => {
                this.array_graficas = response.data;
                this.graficasCargadas = true;
            });

            MasterdataService.getEnlacesObjetivos().then((response) => {
                this.enlacesObjetivos = response.data.objetivos.map((objetivo) => ({
                    ...objetivo,
                    texto: this.$t(objetivo.texto),
                }));
                this.enlacesAgenda2030 = response.data.agenda_2030;
            });
        },
    },
};
</script>
<style scoped>
.theme--light.v-sheet--outlined {
    border: 0;
}

.titulo-detalle {
    word-break: break-word;
}

@media (max-width: 960px) {
    .v-card__text {
        padding: 0px !important;
    }
}
</style>
